.node {
    position: relative;
    /* Off-screen rows skip style and layout work; a row is 32px tall. */
    content-visibility: auto;
    contain-intrinsic-size: auto 32px;

    &:not([data-level='1'])::before {
        top: 16px;
    }
}

.subtree > .node:last-child::after {
    height: 16px;
}

.label {
    position: relative;

    &:where([data-selected]) {
        background-color: transparent !important;
    }
}
